import { createCustomEnum } from "../customEnum";

const ValueTypes = createCustomEnum({
	String: {
		value: 0,
		name: "expense",
		displayName: "Expense",
	},
	Decimal: {
		value: 1,
		name: "volume",
		displayName: "Volume",
	},
	DataTime: {
		value: 2,
		name: "revenue",
		displayName: "Revenue",
	},
	Integer: {
		value: 3,
		name: "count",
		displayName: "Count",
	},
});

export default ValueTypes;
